import SectionHub from '@/components/docs/SectionHub';

export default function Docs03FundamentalsCorpIntelligenceHub() {
  return <SectionHub sectionPath="03-fundamentals/corp.-intelligence" />;
}
